import React from 'react'
import { EmblaOptionsType } from 'embla-carousel'
import useEmblaCarousel from 'embla-carousel-react'
import ClassNames from 'embla-carousel-class-names'
import {
  NextButton,
  PrevButton,
  usePrevNextButtons
} from './EmblaCarouselArrowButtons'
import { importAll } from '../../../functionallity/imageLoader'

type PropType = {
  slides: { image: string, title: string, description: string, link?: string }[] // Bilder mit individuellem Text
  options?: EmblaOptionsType
}

// Bilder importieren
const images = importAll(require.context('../../../../assets/images/KidsPlayground/Carousel', false, /\.(png)$/));

const EmblaCarousel: React.FC<PropType> = (props) => {
  const { slides, options } = props
  const startOptions: EmblaOptionsType = { 
    ...options, 
    startIndex: 1, 
    align: 'center', 
    containScroll: 'trimSnaps' 
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(startOptions, [ClassNames()])

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi)

  return (
    <div className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {slides.map((slide, index) => (
            <div className="embla__slide embla__class-names" key={index}>
              <img 
                className='embla__slide__img' 
                style={{ objectPosition: 'center' }} 
                src={slide.image} 
                alt={slide.title} 
              />              {/* Overlay für Text */}
              <div className="embla__overlay">
                <h2 className="embla__title">{slide.title}</h2>
                <p className="embla__description">{slide.description}</p>
                {slide.link && <a href={slide.link} className="embla__link">Als PDF ausdrucken →</a>}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="embla__controls">
        <div className="embla__buttons">
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        </div>
      </div>
    </div>
  )
}

export default EmblaCarousel
